

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { PaymentVoucherList } from "../../components/PaymentVoucherList/PaymentVoucherList";


export const PaymentVoucherListPage = () => {
    return (
        <AuthenticatedLayout
            pageTitle="Payment Voucher List"
            pageTitleIcon={<DescriptionOutlinedIcon />}
            breadcrumbCurrentPageName=""
            mainContents={<PaymentVoucherList />}
        />
    );
};
